function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function t(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
window.crypto || (window.crypto = window.msCrypto);
var e = function e() {
  try {
    return function () {
      for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21, e = "", n = crypto.getRandomValues(new Uint8Array(t)); t--;) {
        var r = 63 & n[t];
        e += r < 36 ? r.toString(36) : r < 62 ? (r - 26).toString(36).toUpperCase() : r < 63 ? "_" : "-";
      }
      return e;
    }(36);
  } catch (t) {
    return Date.now() + Math.random().toString(36).slice(2);
  }
};
var n = function n() {
  t(this, n), this.pvId = e();
};
n.setPvIdInGlobal = function (t) {
  window.__PAYMENT_SDK_PVID__ = t;
}, n.getPvIdInGlobal = function () {
  return window.__PAYMENT_SDK_PVID__;
};
var r = function r() {
    var t = n.getPvIdInGlobal();
    if (t) return t;
    var e = new n().pvId;
    return n.setPvIdInGlobal(e), e;
  },
  o = r();
function i(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function s(t, e, n) {
  return e && i(t.prototype, e), n && i(t, n), t;
}
var a = {
    development: "",
    production: ""
  },
  c = a.production,
  u = a.development,
  f = "1.7.1",
  l = function () {
    function e() {
      t(this, e);
      var n = navigator.userAgent;
      this.ua = n, this.os = this.detectOS(this.ua), this.os_version = this.detectOSVersion(this.ua, this.os), this.browser = this.detectBrowser(this.ua), this.browser_version = this.detectBrowserVersion(this.ua, this.browser);
    }
    return s(e, [{
      key: "detectOS",
      value: function value(t) {
        switch (!0) {
          case /Android/.test(t):
            return "Android";
          case /iPhone|iPad|iPod/.test(t):
            return "iOS";
          case /Windows/.test(t):
            return "Windows";
          case /Mac OS X/.test(t):
            return "Mac";
          case /CrOS/.test(t):
            return "Chrome OS";
          case /Firefox/.test(t):
            return "Firefox OS";
        }
        return "";
      }
    }, {
      key: "detectOSVersion",
      value: function value(t, e) {
        switch (e) {
          case "Android":
            return this.getVersion(t, "Android");
          case "iOS":
            return this.getVersion(t, /OS /);
          case "Windows":
            return this.getVersion(t, /Phone/.test(t) ? /Windows Phone (?:OS )?/ : /Windows NT/);
          case "Mac":
            return this.getVersion(t, /Mac OS X /);
        }
        return "0.0.0";
      }
    }, {
      key: "getVersion",
      value: function value(t, e) {
        try {
          return this.normalizeSemverString(t.split(e)[1].trim().split(/[^\w.]/)[0]);
        } catch (t) {}
        return "0.0.0";
      }
    }, {
      key: "normalizeSemverString",
      value: function value(t) {
        var e = t.split(/[._]/);
        return (parseInt(e[0], 10) || 0) + "." + (parseInt(e[1], 10) || 0) + "." + (parseInt(e[2], 10) || 0);
      }
    }, {
      key: "detectBrowser",
      value: function value(t) {
        var e = /Android/.test(t);
        switch (!0) {
          case /CriOS/.test(t):
            return "Chrome for iOS";
          case /Edge/.test(t):
            return "Edge";
          case e && /Silk\//.test(t):
            return "Silk";
          case /Chrome/.test(t):
            return "Chrome";
          case /Firefox/.test(t):
            return "Firefox";
          case e:
            return "AOSP";
          case /MSIE|Trident/.test(t):
            return "IE";
          case /Safari\//.test(t):
            return "Safari";
          case /AppleWebKit/.test(t):
            return "WebKit";
        }
        return "";
      }
    }, {
      key: "detectBrowserVersion",
      value: function value(t, e) {
        switch (e) {
          case "Chrome for iOS":
            return this.getVersion(t, "CriOS/");
          case "Edge":
            return this.getVersion(t, "Edge/");
          case "Chrome":
            return this.getVersion(t, "Chrome/");
          case "Firefox":
            return this.getVersion(t, "Firefox/");
          case "Silk":
            return this.getVersion(t, "Silk/");
          case "AOSP":
            return this.getVersion(t, "Version/");
          case "IE":
            return /IEMobile/.test(t) ? this.getVersion(t, "IEMobile/") : /MSIE/.test(t) ? this.getVersion(t, "MSIE ") : this.getVersion(t, "rv:");
          case "Safari":
            return this.getVersion(t, "Version/");
          case "WebKit":
            return this.getVersion(t, "WebKit/");
        }
        return "0.0.0";
      }
    }]), e;
  }();
function h(t) {
  return (h = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(t);
}
function d(t) {
  if ("object" !== h(t)) return "";
  var e = [];
  for (var n in t) {
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      var r = encodeURIComponent(t[n]);
      e.push("".concat(n, "=").concat(r));
    }
  }
  return e.join("&");
}
function p(t) {
  try {
    var e = "ajax" === t.mode && "post" === t.method,
      n = !!t.headers && Object.keys(t.headers).length > 0;
    return e && !n && window.navigator && "function" == typeof window.navigator.sendBeacon;
  } catch (t) {
    return !1;
  }
}
var g = new (function () {
    function e() {
      t(this, e), this.buildUrl = function (t, e) {
        var n = Object.prototype.toString.call(e);
        return e && "[object Object]" === n ? (t = decodeURIComponent(t).indexOf("?") > -1 ? "".concat(t, "&") : "".concat(t, "?")) + d(e) : t;
      };
    }
    return s(e, [{
      key: "get",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        t = this.buildUrl(t, e.params);
        var n = {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8"
        };
        return this.http(t, Object.assign(Object.assign({
          method: "GET"
        }, e), {
          headers: Object.assign(Object.assign({}, n), e.headers)
        }));
      }
    }, {
      key: "post",
      value: function value(t, e) {
        var n,
          r,
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = {
            Accept: "application/json"
          },
          s = e || o.data,
          a = (null === (n = null == o ? void 0 : o.headers) || void 0 === n ? void 0 : n["Content-Type"]) && /application\/json/.test(null === (r = null == o ? void 0 : o.headers) || void 0 === r ? void 0 : r["Content-Type"]) ? "json" : "form";
        return "form" === a ? (i["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", s = d(s)) : (i["Content-Type"] = "application/json;charset=UTF-8", s = s ? JSON.stringify(s) : null), this.http(t, Object.assign(Object.assign({
          method: "POST",
          body: s
        }, o), {
          headers: Object.assign(Object.assign({}, i), o.headers)
        }));
      }
    }, {
      key: "http",
      value: function value(t, e) {
        return new Promise(function (n, r) {
          var o = new XMLHttpRequest(),
            i = e.body,
            s = function (t, e) {
              var n = {};
              for (var r in t) {
                Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
              }
              if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                var o = 0;
                for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
                  e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
                }
              }
              return n;
            }(e, ["body"]);
          for (var a in o.open(e.method, t), e.headers) {
            Object.prototype.hasOwnProperty.call(e.headers, a) && o.setRequestHeader(a, e.headers[a]);
          }
          o.onreadystatechange = function () {
            if (4 === o.readyState) {
              var e = {
                  options: s,
                  statusCode: o.status,
                  url: t
                },
                i = "";
              try {
                i = JSON.parse(o.responseText);
              } catch (t) {
                i = o.responseText;
              }
              if (/^(2|3)\d{2}$/.test(o.status.toString())) {
                try {
                  n(Object.assign({
                    data: i
                  }, e));
                } catch (t) {
                  n(Object.assign({
                    data: i
                  }, e));
                }
                return;
              }
              r(Object.assign({
                data: i
              }, e));
            }
          }, o.send(i), o.onerror = function (t) {
            throw t;
          };
        });
      }
    }]), e;
  }())(),
  b = 0;
function v(t, e) {
  var n = t.url,
    r = t.mode,
    o = t.method,
    i = t.headers,
    s = t.onError;
  if (n && !(b >= 5)) if ("image" !== r) "ajax" !== r || "post" !== o ? "ajax" !== r || "get" !== o || g.get(n, {
    params: e,
    headers: i
  })["catch"](function (t) {
    b += 1, "function" == typeof s && s(t), console.log("linkMonitor:", t);
  }) : g.post(n, e, {
    headers: i
  })["catch"](function (t) {
    b += 1, "function" == typeof s && s(t), console.log("linkMonitor:", t);
  });else try {
    !function (t, e, n) {
      var r = new Image(1, 1),
        o = d(e),
        i = "".concat(t, "?").concat(o);
      r.onerror = function () {
        "function" == typeof n && n(new Error("linkMonitor: fail to get img"));
      }, r.onload = function () {}, r.src = i;
    }(n, e, s);
  } catch (t) {
    b += 1, console.log("linkMonitor:", t);
  }
}
function y(t) {
  var e,
    n,
    r,
    o = "";
  for (e = 0, n = (t += "").length; e < n; e++) {
    o += (r = t.charCodeAt(e).toString(16)).length < 2 ? "0" + r : r;
  }
  return o;
}
function w(t, e) {
  return (w = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
function O(t, e) {
  return !e || "object" !== h(e) && "function" != typeof e ? function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }(t) : e;
}
function m(t) {
  return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function S() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}
function _(t, e, n) {
  return (_ = S() ? Reflect.construct : function (t, e, n) {
    var r = [null];
    r.push.apply(r, e);
    var o = new (Function.bind.apply(t, r))();
    return n && w(o, n.prototype), o;
  }).apply(null, arguments);
}
function j(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (j = function j(t) {
    if (null === t || (n = t, -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
    var n;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }
    function r() {
      return _(t, arguments, m(this).constructor);
    }
    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), w(r, t);
  })(t);
}
function k(t) {
  var e = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = m(t);
    if (e) {
      var o = m(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return O(this, n);
  };
}
var C = function (e) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && w(t, e);
    }(r, j(Error));
    var n = k(r);
    function r(e) {
      var o;
      return t(this, r), (o = n.call(this, e)).name = "LinkMonitorError", o.message = "[LinkMonitorError]: " + e || "[LinkMonitorError]: Error", o;
    }
    return r;
  }(),
  I = function () {
    function n(e, r) {
      var o = this;
      if (t(this, n), this.act = "", this.reportNetworkConfig = {}, this.defaultOptions = {}, this.bs_queue = 0, this.queue = [], this.queueIsRIFScheduled = !1, this.upload = function (t) {
        if (o.queueIsRIFScheduled = !1, t || (t = {
          didTimeout: !0,
          timeRemaining: function timeRemaining() {
            return Number.MAX_VALUE;
          }
        }), (null == t ? void 0 : t.timeRemaining()) > 0 || o.queue.length > 0) {
          var e = o.queue.shift();
          e && v(e.reportNetworkConfig, e.reportData);
        }
        o.queue.length > 0 && o.upload();
      }, this.sendBeacon = function (t) {
        !function (t, e) {
          var n = t.url,
            r = t.onError;
          if (n && !(b >= 5)) try {
            navigator.sendBeacon(t.url, URLSearchParams ? new URLSearchParams(e) : d(e));
          } catch (t) {
            b += 1, "function" == typeof r && r(t);
          }
        }(t.reportNetworkConfig, t.reportData);
      }, !e) throw new C("Core class initialization requires the act field");
      this.act = e, this.reportNetworkConfig = r, this.getDefaultOptions();
    }
    return s(n, [{
      key: "updateReportNetworkConfig",
      value: function value(t) {
        this.reportNetworkConfig = Object.assign(Object.assign({}, this.reportNetworkConfig), t);
      }
    }, {
      key: "getDefaultOptions",
      value: function value() {
        var t,
          e = this.act,
          n = f,
          r = {
            bs_ua: (t = new l()).ua,
            bs_os: t.os,
            bs_os_version: t.os_version,
            bs_browser: t.browser,
            bs_browser_version: t.browser_version
          },
          o = {
            bs_screen_height: window.screen.height,
            bs_screen_width: window.screen.width,
            bs_color_depth: window.screen.colorDepth.toString()
          },
          i = window.navigator.javaEnabled().toString(),
          s = new Date().getTimezoneOffset().toString(),
          a = window.navigator.language,
          c = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "2021-12-08";
            try {
              var e = document.createElement("canvas"),
                n = e.getContext("2d"),
                r = t;
              if (!n) return Date.now() + Math.random().toString(36).slice(2);
              n.textBaseline = "top", n.font = "14px 'Arial'", n.textBaseline = "tencent", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.fillText(r, 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.7)", n.fillText(r, 4, 17);
              var o = e.toDataURL().replace("data:image/png;base64,", "");
              return y(window.atob(o).slice(-16, -12));
            } catch (t) {
              return Date.now() + Math.random().toString(36).slice(2);
            }
          }();
        this.defaultOptions = Object.assign(Object.assign(Object.assign({
          act: e,
          bs_lib_plugin_version: n
        }, r), o), {
          bs_java_enabled: i,
          bs_time_zone_offset: s,
          bs_language: a,
          fg: c
        });
      }
    }, {
      key: "getDefaultDynamicOptions",
      value: function value() {
        var t = Date.now(),
          n = Math.floor(t / 1e3),
          r = document.title,
          i = window.location.href,
          s = document.referrer,
          a = {
            bs_viewport_height: document.documentElement.offsetHeight || document.body.offsetHeight,
            bs_viewport_width: document.documentElement.offsetWidth || document.body.offsetWidth
          },
          c = a.bs_viewport_height,
          u = a.bs_viewport_width,
          f = this.bs_queue++,
          l = e();
        return {
          pvId: o,
          time: n,
          bs_create_time: t,
          bs_title: r,
          bs_url: i,
          bs_referrer: s,
          bs_viewport_height: c,
          bs_viewport_width: u,
          bs_queue: f,
          bs_uuid: l
        };
      }
    }, {
      key: "send",
      value: function value(t, e) {
        var n = this.getDefaultDynamicOptions(),
          r = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), n), {
            eventName: t
          }), e),
          o = p(this.reportNetworkConfig),
          i = {
            reportNetworkConfig: this.reportNetworkConfig,
            reportData: r
          };
        o ? this.sendBeacon(i) : (this.queue.push(i), this.queueUpload());
      }
    }, {
      key: "queueUpload",
      value: function value() {
        var t, e;
        this.queueIsRIFScheduled || (this.queueIsRIFScheduled = !0, t = this.upload, e = {
          timeout: 2e3
        }, "requestIdleCallback" in window ? window.requestIdleCallback(t, e) : setTimeout(t, 0));
      }
    }]), n;
  }(),
  E = {
    debug: !1,
    url: c,
    mode: "ajax",
    method: "post"
  },
  P = function () {
    function e(n, r) {
      t(this, e), this.businessDefaultOptions = {
        version: "0.0.0",
        environment: "production"
      }, this.act = n, this.options = Object.assign(Object.assign({}, E), r), this.options.debug && (this.options.url = u), this.fedLog = new I(n, {
        url: this.options.url,
        mode: this.options.mode,
        method: this.options.method,
        headers: this.options.headers
      });
    }
    return s(e, [{
      key: "init",
      value: function value(t, e) {
        e && this.fedLog.updateReportNetworkConfig(e), this.businessDefaultOptions = Object.assign(Object.assign({}, this.businessDefaultOptions), t);
      }
    }, {
      key: "report",
      value: function value(t, e) {
        var n = function (t) {
            var e = {};
            for (var n in t) {
              if (Object.prototype.hasOwnProperty.call(t, n)) {
                var r = t[n];
                e[n] = r instanceof Object ? JSON.stringify(r) : r;
              }
            }
            return e;
          }(e),
          r = Object.assign(Object.assign({}, this.businessDefaultOptions), n);
        this.fedLog.send(t, r);
      }
    }]), e;
  }();
export { P as Monitor, r as getPvId, o as pvId };